import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { WpProvider } from "../../providers/wp/wp";
import { AppConfigProvider } from "../../providers/app-config/app-config";


/**
 * Generated class for the SettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {

  authorized = false;
  password: String = '';

  constructor(
      public navCtrl: NavController,
      public wpProvider: WpProvider,
      public appConfig: AppConfigProvider,
      public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingsPage');
  }


  authorize(){

  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts